import { Container } from "reactstrap";
import AppPageHeader from "../../../../components/Headers/AppPageHeader";
import { Suspense, lazy, useState } from "react";

const SchemaComparisonDrawer = lazy(() => import("./SchemaComparisonDrawer"));

export default function SchemaComparison() {
  const [schemaCompareDrawer, setSchemaCompareDrawer] = useState(true);

  return (
    <>
      <div className="header pb-6">
        <Container fluid>
          <AppPageHeader
            title="Schema Comparison"
            description="Compare and reconcile database schemas"
            actionButtonName="New"
            actionButtonColor="primary"
            action={() => setSchemaCompareDrawer(true)}
          />
        </Container>
      </div>
      <Suspense fallback={<></>}>
        <SchemaComparisonDrawer
          open={schemaCompareDrawer}
          onClose={() => setSchemaCompareDrawer(false)}
        />
      </Suspense>
    </>
  );
}
